<div class="mct-flex mct-col mct-gap-5" *ngIf="chartDataReady"  >
  <div class="mct-flex mct-row mct-justify-between mct-items-center"  >
    <div>
      <span class="progress-total-pledged">{{ totalPledged | currency }}</span>
    </div>
    <div>
      <span class="progress-campaign-goal">{{ pledgeCampaignGoal | currency }}</span>
    </div>
  </div>
  <div class="progress-bar-wrapper w-100">
    <p-chart *ngIf="chartDataReady" type="bar" [data]="chartData" [options]="chartOptions" width="100%" height="40px"></p-chart>
  </div>
  <div class="mct-flex mct-row mct-justify-between mct-items-center"  >
    <div>
      <span class="progress-donor-count"
        >{{ donorCount }}
        {{ 'revenue.pledge-campaigns.pledge-campaign.edit.pledge-campaign-details.progress-bar.donors' | translate | titlecase }}</span
      >
    </div>
    <div>
      <span [hidden]="campaignEndDatePassed" class="progress-time-remaining">
        <span *ngIf="yearsRemaining > 1">
          {{ yearsRemaining }}
          {{ 'revenue.pledge-campaigns.pledge-campaign.edit.pledge-campaign-details.progress-bar.years' | translate }}
        </span>
        <span *ngIf="monthsRemaining >= 1">
          {{ monthsRemaining }}
          {{ 'revenue.pledge-campaigns.pledge-campaign.edit.pledge-campaign-details.progress-bar.months' | translate }}
        </span>
        <span *ngIf="monthsRemaining < 1 && yearsRemaining < 1">
          < 1
          {{ 'revenue.pledge-campaigns.pledge-campaign.edit.pledge-campaign-details.progress-bar.months' | translate }}
        </span>
        <span>
          {{ 'revenue.pledge-campaigns.pledge-campaign.edit.pledge-campaign-details.progress-bar.remaining' | translate }}
        </span>
      </span>
      <span [hidden]="!campaignEndDatePassed" class="progress-end-date-passed">
        {{ 'revenue.pledge-campaigns.pledge-campaign.edit.pledge-campaign-details.progress-bar.campaign-end-date-passed' | translate | ucfirst }}
      </span>
    </div>
  </div>
</div>
